module.exports = __webpack_public_path__ + "static/media/10.18433550.jpg";